// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CP99M","form":"styles_form__myY+D","grid":"styles_grid__goj79"};